import config from '@/config';

const BASE_URL = config.API_BASE_URL;

const ENDPOINTS = {
  // auth
  authMessage: `${BASE_URL}/auth/auth-message`,
  login: `${BASE_URL}/auth/sign-in`,
  logout: `${BASE_URL}/auth/sign-out`,
  userInfo: `${BASE_URL}/user/user-info`,
  updateUserInfo: `${BASE_URL}/user/update-user-info`,
  uploadImage: `${BASE_URL}/upload-image`,

  // email verification
  sendEmailBondCode: `${BASE_URL}/auth/send-email-bond-code`,
  verifyEmailBondCode: `${BASE_URL}/auth/verify-email-bond-code`,
  emailVerificationStatus: `${BASE_URL}/auth/email-verification-status`,

  // Junk.Fun game endpoints
  dump: `${BASE_URL}/dump`,
  history: `${BASE_URL}/user/history`,
  solHistory: `${BASE_URL}/chest/sol-history`,
  progress: `${BASE_URL}/user/progress`,
  pools: `${BASE_URL}/pools`,
  tokens: `${BASE_URL}/tokens`,

  // Points lottery endpoints
  pointsLotteryCurrent: `${BASE_URL}/points-lottery/current`,
  pointsLotteryContribute: `${BASE_URL}/points-lottery/contribute`,
  pointsLotteryHistory: `${BASE_URL}/points-lottery/history`,
  pointsLotteryRank: `${BASE_URL}/points-lottery/rank`,
  pointsLotteryClaim: `${BASE_URL}/points-lottery/claim`,
  pointsLotterySeasonResults: `${BASE_URL}/points-lottery/season`, // Use with /{seasonId}/results
  pointsLotterySeasonActivity: `${BASE_URL}/points-lottery/season`, // Use with /{seasonId}/user-activity
  pointsLotteryNFTUnclaimed: `${BASE_URL}/points-lottery/nft/unclaimed`,
  pointsLotteryNFTUser: `${BASE_URL}/points-lottery/nft/user`,
  pointsLotteryNFTConfirm: `${BASE_URL}/points-lottery/nft/confirm`,
  pointsLotteryRewardVerifyAndClaim: `${BASE_URL}/points-lottery/reward/verify-and-claim`,
  pointsLotteryShareResult: `${BASE_URL}/points-lottery/share-result`,
  pointsBalance: `${BASE_URL}/points/balance`,
  pointsLedger: `${BASE_URL}/points/ledger`,

  // Points leaderboard endpoints (separate from lottery leaderboard)
  pointsLeaderboardList: `${BASE_URL}/leaderboard/points/list`,
  pointsLeaderboardMyRank: `${BASE_URL}/leaderboard/points/my-rank`,

  // Referral endpoints
  referralStats: `${BASE_URL}/referral/stats`,
  referralBind: `${BASE_URL}/referral/bind`,
  referralClaim: `${BASE_URL}/referral/claim`,

  // Chest/Jackpot endpoints - Backend signing server
  // Note: Backend server should run on localhost:3000 and provide the signer authority co-signature
  openChest: `${BASE_URL}/chest/prepare-open`,
  chestMintNFT: `${BASE_URL}/chest/mint-nft`,

  // Transaction order endpoints
  txOrderGenerateSignature: `${BASE_URL}/tx-order/generate-signature`,

  // Social task endpoints
  socialTaskStatus: `${BASE_URL}/auth/social-task/status`,
  socialTaskComplete: `${BASE_URL}/auth/social-task/complete`,

  // Twitter endpoints
  twitterAuthUrl: `${BASE_URL}/twitter/auth-url`,
  twitterVerifyLotteryShare: `${BASE_URL}/twitter/verify-lottery-share`,
  twitterVerifyNFTMint: `${BASE_URL}/twitter/verify-nft-mint`,

  // Breakpoint campaign endpoints
  breakpointCampaignStatus: `${BASE_URL}/campaigns/breakpoint/status`,
  breakpointCampaignVerify: `${BASE_URL}/campaigns/breakpoint/verify`,
  breakpointCampaignClaim: `${BASE_URL}/campaigns/breakpoint/claim`,

  // Share image generation endpoints
  shareImageLottery: `${BASE_URL}/share-image/lottery`,
  shareImageLotteryTweetText: `${BASE_URL}/share-image/lottery/tweet-text`,
  shareImageNFTTweetText: `${BASE_URL}/share-image/nft/tweet-text`,
  shareImageLotteryAutoPost: `${BASE_URL}/share-image/lottery/auto-post`,
  shareImageNFTAutoPost: `${BASE_URL}/share-image/nft/auto-post`,

  // Wrapped 2025 endpoints
  wrappedAccess: `${BASE_URL}/wrapped/access`,
  wrappedData: `${BASE_URL}/wrapped`,
  wrappedComplete: `${BASE_URL}/wrapped/complete`,
  wrappedShare: `${BASE_URL}/wrapped/share`,

  // New Year Campaign 2026 endpoints
  newYearCampaignStatus: `${BASE_URL}/new-year-campaign/status`,
  newYearCampaignTasks: `${BASE_URL}/new-year-campaign/tasks`,
  newYearCampaignCheckin: `${BASE_URL}/new-year-campaign/checkin`,
  newYearCampaignLeaderboard: `${BASE_URL}/new-year-campaign/leaderboard`,
  newYearCampaignVerifyTweet: `${BASE_URL}/new-year-campaign/verify-tweet`,
};

export default ENDPOINTS;

export function buildUrl(
  base: string,
  params?: { [key: string]: string | number | boolean | null | undefined }
) {
  const url = new URL(base, BASE_URL);
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        url.searchParams.set(key, String(value));
      }
    });
  }
  return url.toString();
}
